export default function ({ redirect, app }) {
  if (!app.$tenantConfig.isPlatformClosed || app.$auth.isAuthenticated) {
    return Promise.resolve()
  }
  return redirect(app.localePath('login'))
}
